@let demarchesList = demarches();

@if(currentFamily() && config()){
@if(demarchesList?.length > 0) {
<div class="demarches-container">
  <div style="text-align: center;">
    <h2 class="primary">{{ 'demarches.demarches_available' | trans }}</h2>
  </div>
  @for (demarche of demarchesList; track $index) {
  <div (click)="onClickDemarche(demarche)" class="demarche-item">
    <div class="fx-direction-row fx-align-item-center">
      <ng-container *ngTemplateOutlet="showIcon; context: { data: demarche }"></ng-container>
      <span>{{ demarche.label }}</span>
      @if(demarche.hasProgress){
      <mat-icon matTooltip="Démarche en pause" color="accent" style="margin-left: 5px;">pause_circle</mat-icon>
      }
    </div>
    <mat-icon color="primary" style="margin-left: 3px;">arrow_right_alt</mat-icon>
  </div>
  }
</div>
}@else {
<div style="text-align: center;">
  <h2>{{ 'demarches.no_demarches' | trans }}</h2>
</div>
}
}@else {
<app-loader [message]="'Chargement des données...'" class="margin"></app-loader>
}

<ng-template #showIcon let-data="data">
  <mat-icon *ngIf="data.icon && !data.iconDomino && !data.iconFontawesome" class="main-icon">
    {{ data.icon }}
  </mat-icon>
  <app-icon *ngIf="data.iconFontawesome || data.iconDomino"
    [icon]="data.iconFontawesome ? data.iconFontawesome : data.iconDomino" [type]="
      data.iconDomino
        ? 'do'
        : !data.typeIcon && data.iconFontawesome
        ? 'fa'
        : data.typeIcon
    " [size]="24" style="margin-right: 12px">
  </app-icon>
</ng-template>
